module.exports = __webpack_public_path__ + "images/sp/common/estimate_btn_0ac48156d247a26f3fcec0011285b8f5.png";